<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For Jack and Ray Good friends can be hard to find</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter.vue?12539b72